import axios from "axios"

export const register = async (payload) => {
  const finalUrl =
      window._HOST + "participant/registration"

  const response =
      await axios.post(finalUrl, payload)

  return response.data
}

export const getProgram = async () => {
  const finalUrl =
      window._HOST + "public/program"

  const response =
      await axios.get(finalUrl)

  return response.data
}

export async function getAvailableJenjang() {

  const finalUrl = window._HOST + "public/available-jenjang"

  const response = await axios.get(finalUrl)

  return response.data

}

export async function filterAvailableProgram(idJenjang, jenisPembiayaan) {

  const finalUrl = 
    window._HOST + "public/program-by-jenjang?id-jenjang=" + idJenjang + "&jenis-pembiayaan=" + jenisPembiayaan

  const response = await axios.get(finalUrl)

  return response.data

}